/**
 * wireLobbyLoadoutPersistence — Restore + save lobby loadout locally (SPY-115).
 */

import {
  applyLobbyLoadout,
  readLobbyLoadout,
  serializeLobbyLoadout,
  writeLobbyLoadout
} from './lobbyLoadoutPersistence.js';

/**
 * @param {{
 *   session: object,
 *   storage?: object|null,
 *   globalObj?: object|null
 * }} opts
 */
export function wireLobbyLoadoutPersistence({
  session,
  storage = typeof localStorage !== 'undefined' ? localStorage : null,
  globalObj = typeof window !== 'undefined' ? window : null
} = {}) {
  applyLobbyLoadout(session, readLobbyLoadout(storage));

  function persist() {
    return writeLobbyLoadout(storage, serializeLobbyLoadout(session));
  }

  function get() {
    return serializeLobbyLoadout(session);
  }

  const api = { persist, get, read: () => readLobbyLoadout(storage) };
  if (globalObj) globalObj.__debugLobbyLoadout = api;
  return api;
}
